export default (props, e) => {
	const target = (document.querySelector(e.target.getAttribute('href')));

	if (target) {
		e.preventDefault();
		target.scrollIntoView({behavior: 'smooth'});
	}
};




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/scrollToHref.js